import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { DownloadFileComponent } from './download-file/download-file.component';
import { StripeConnectCallbackComponent } from './stripe-connect-callback/stripe-connect-callback.component';
const routes: Routes = [
  {
    path: 'stripe/connect/callback',
    component: StripeConnectCallbackComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },


  {
    path: 'clinic',
    loadChildren: () =>
      import('./features/clinic/clinic.module').then((m) => m.ClinicModule),
  },
  {
    path: 'download/:id1/:id2/:id3',
    component: DownloadFileComponent,
  },
  {
    path: 'patient/appointment-video-call',
    redirectTo: 'clinic/appointment-video-call',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'pageNotFound',
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
